module.exports = __webpack_public_path__ + "static/img/cancel.8b10d4e5.png";